module.exports = __webpack_public_path__ + "img/button_my_reward.72b4df82.png";